import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export default function DelegateActiveTabReducer(state = initialState.delegateActiveTab, action) {
	switch (action.type) {
		case types.SET_DELEGATE_ACTIVE_TAB: {
			return action.tab;
		}
		default:
			return state;
	}
}
